// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingButton_spinner__s2jS-","box":"LoadingButton_box__40uSH"};